export const FUND_WALLET_COLORS = [
  '#FF0000',
  '#006B6B',
  '#7BA81C',
  '#B500B5',
  '#FF8787',
  '#2E96FF',
  '#223499',
  '#FF7A00',
  '#B50000',
  '#17A68C',
  '#8F8A00',
  '#8A2BE2',
  '#3477DB',
  '#D48364',
  '#800000',
  '#03A0B5',
  '#BC8A0B',
  '#483D8B',
  '#0F6C78',
  '#076DBB',
  '#B8540B',
  '#886288',
];
